import { Component, EventEmitter, Input, OnChanges, SimpleChanges } from '@angular/core';

import * as _ from 'lodash';

@Component({
    selector: 'tree-view',
    template: `<ul *ngIf="items">
    <li *ngFor="let item of items" 
        [contextMenu]="options.contextMenu" [contextMenuValue]="item">
        <i class="glyphicon" 
            [ngClass]="{ 'glyphicon-chevron-right': ! item.expanded, 'glyphicon-chevron-down': item.expanded }"
            (click)="toggleItem(item)"></i>
        <p class="tree-label" 
            [ngClass]="{ 'bg-primary': item.id == options.selectedItem?.id }"
            (click)="selectItem(item)">
            {{item[options.displayField]}}
        </p>
        <tree-view *ngIf="item.expanded" [items]="item[options.childrenField]" [options]="options"></tree-view>        
    </li>
</ul>`,
    styles: [
        'ul { list-style-type: none; padding-top: .5em; padding-left: 0; }',
        'ul ul { padding-top: 0; padding-left: 1em; }',
        'li { cursor: pointer; }',
        'li .tree-label { display: inline-block; margin-bottom: .25em; margin-left: .25em; padding: .5em; border-radius: 3px; }'
    ]
})
export class TreeViewComponent implements OnChanges {

    @Input() items = [];

    @Input() options: any = {};

    private treeOptions: any = {
        displayField: 'name',
        childrenField: 'children',
        selectedItem: null,
        getChildren: null,
        contextMenu: null,
        onSelectItem: new EventEmitter<any>()
    };

    constructor() { }

    ngOnChanges(changes: SimpleChanges): void {
        this.treeOptions = _.extend(this.treeOptions, this.options);
    }

    toggleItem(item) {
        item.expanded = (! item.expanded);
        if (item.expanded) {
            this.getChildren(item)
            .then(  
                () => {}, // Ignore
                () => {}  // Ignore
            );            
        }
    }

    selectItem(item) {
        this.options.selectedItem = item;
        this.options.onSelectItem && this.options.onSelectItem(item);
    }

    getChildren(item) {
        if (item?.fetched) {
            return Promise.reject();
        }

        item['fetched'] = true;

        const fn = this.treeOptions.getChildren;
        if (fn) {
            return fn(item);
        }

        return Promise.resolve([]);
    }
}
